import { Dispatch, SetStateAction, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useApiCall from '../../../hooks/useApiCall';
import useGetGeneralAppData from '../../../hooks/useGetGeneralAppData';
import { useQuery } from '../../../hooks/useQuery';
import ConsultsService from '../../../services/ConsultsService';
import MyModal from '../../Modal';

interface IImplantationModal {
  email: string;
  myLinkModalShow: boolean;
  setMyLinkModalShow: Dispatch<SetStateAction<boolean>>;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  getResult: () => Promise<void>;
}

export default function SendMyLinkModal({
  email,
  myLinkModalShow,
  setMyLinkModalShow,
  setIsLoading,
  getResult
}: IImplantationModal) {
  const { consultCode } = useParams();
  const { apiCall } = useApiCall();
  const { userCode, userProfile, userName } = useGetGeneralAppData();
  const query = useQuery();
  const companyCode = query.get('codEmpresa');

  const sendMyLinkEmail = useCallback(async () => {
    await apiCall({
      apiToCall: ConsultsService.sendMyLinkEmail,
      reqBody: JSON.stringify({
        codUsu: userCode,
        perfilUsu: userProfile,
        usuario: userName,
        codEmpresa: Number(companyCode),
        codConsulta: Number(consultCode),
        tipoMail: 1,
        mail: email,
      }),
      onStartLoad: () => setIsLoading(true),
      onEndLoad: () => setIsLoading(false),
      actionAfterResponse: async (response) => {
        if (!response.codigo) {
          toast.error(`Não foi possível enviar o e-mail com o resultado do my-link. Por favor, tente novamente (${response.msg})`);
          return;
        }

        setMyLinkModalShow(false);
        await getResult();
        toast.success('O e-mail com o resultado do my-link foi enviado com sucesso!');
      },
      catchMessage: 'Não foi possível enviar o e-mail com o resultado do my-link. Por favor, tente novamente',
    });
  }, [apiCall, companyCode, consultCode, email, getResult, setIsLoading, setMyLinkModalShow, userCode, userName, userProfile]);

  return (
    <MyModal
      show={myLinkModalShow}
      onClose={() => setMyLinkModalShow(false)}
      title={'Enviar Resultado My-Link para o e-mail do funcionário'}
      centeredBody
      modalBody={(
        <>
          Tem certeza que deseja enviar esse resultado para o e-mail
          <strong>
            {email}
          </strong>
        </>
      )}
      closeButtonLabel="Fechar"
      size="lg"
      type='action'
      actionButtonLabel='Enviar Resultado'
      onAction={() => sendMyLinkEmail()}
    />
  );
}
